import { FC, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { Cancel as CancelIcon } from "@material-ui/icons";
import { usePostHog } from "posthog-js/react";

import { Button, ErrorMessage, Modal } from "components";
import { DEFAULT_ERROR_MESSAGE } from "services/constants";
import { withdrawOffer } from "services/offers";
import { ListingOffer } from "services/offers/types";
import theme from "theme";
import { circleIconSize } from "theme/constants";
interface WithdrawOfferModalProps {
  onClose: () => void;
  listingId: number;
  offer: ListingOffer;
}

const titleByStep = ["Withdraw Offer", "Offer Withdrawn"];

const WithdrawOfferModal: FC<WithdrawOfferModalProps> = ({
  onClose,
  listingId,
  offer,
}) => {
  const posthog = usePostHog();
  const [step, setStep] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");

  const handleWithdraw = async () => {
    try {
      await withdrawOffer(listingId, offer.id, posthog);
      setStep(s => s + 1);
    } catch (e) {
      setErrorMessage(e instanceof Error ? e.message : DEFAULT_ERROR_MESSAGE);
    }
  };
  return (
    <Modal title={titleByStep[step]} open onClose={onClose}>
      {step === 0 && (
        <>
          <Typography component="div" gutterBottom>
            <Box fontSize={13} textAlign="center">
              Are you sure you want to withdraw your offer?
            </Box>
          </Typography>
          {errorMessage && (
            <Box my={2}>
              <ErrorMessage title="Request Failed" description={errorMessage} />
            </Box>
          )}
          <Box my={2}>
            <Button
              customColor="red"
              size="large"
              variant="contained"
              fullWidth
              onClick={handleWithdraw}
            >
              Withdraw Offer
            </Button>
          </Box>
        </>
      )}
      {step === 1 && (
        <>
          <Typography component="div">
            <Box textAlign="center">
              <CancelIcon
                style={{
                  fontSize: circleIconSize.big,
                  color: theme.custom.palette.red.main,
                }}
              />
            </Box>
            <Box fontSize={15} textAlign="center" m={2}>
              Your offer has been successfully withdrawn.
            </Box>
          </Typography>
        </>
      )}
    </Modal>
  );
};

export default WithdrawOfferModal;
